/* eslint-disable import/prefer-default-export */
export const DefaultDebouceDelay = 500;
// Tenant Region Constants
export const TENANT_REGION_ULC = 'nfpa_ulc';
